export default __webpack_public_path__ + "static/media/logo.3fd13447.png";